export default __webpack_public_path__ + "static/media/IU_Home1.a896768a.jpg";